import { useEffect, useState, useContext, useRef, useCallback } from "react"
import { useLocation } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify"

import { useEstadoApp } from "../context/EstadoAppContext";
import {initiateSocketConnection} from "../service/socketio";

import { useLocalStorage } from "../hooks/useLocalStorage";

import TramitacionesComponent from "../components/TramitacionesComponent";

const EVENT_NAME = 'redisKeyDeleted';

export const TramitacionesPage = () => {

	const { estadoAppX, cambiarEstadoApp } = useEstadoApp();

    const location = useLocation();
    //const [showToast, setShowToast] = useState(false); //no usar por ahora
    const { search } = useLocation();
    const { setItem, removeItem } = useLocalStorage();

    const [arrayEditando, setArrayEditando] = useState([]);
    const [socket, setSocket] = useState(null);
    const socketRef = useRef(null);
    const [isSocketConnected, setIsSocketConnected] = useState(false);

    const [isEditing, setIsEditing] = useState(false);

    const [key, setKey] = useState(null); //17oct2025: para claves eliminadas

    const consultar_array_editando = async () => {
        console.log("CONSULTANDO arrayEditando")
        const url = `/api/arrayEditando`;
        const headers = { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' }

        try {
            const response = await fetch(url, {headers});
            const result = await response.json();
            console.log("Datos recibidos en getObras:", result); // Verifica los datos
            if(result){
                setArrayEditando(result);
            } else {
                console.log("No hay datos en arrayEditando")
                setArrayEditando([]);
            }
        } catch (error) {
            console.error('Error al buscar obras:', error);
        }        
    }

    const handleIsEditing = useCallback((newIsEditing) => {
        console.log("EJECUTA??", newIsEditing)
        setIsEditing(newIsEditing);
        setItem("isEditing", isEditing);
    }, []);

    /*useEffect(() => {
        console.log("EJECUTA B - isEditing", isEditing)
        if(isEditing){
            setItem("isEditing", isEditing);
            //setItem("idPartidoObra", idPartidoObra)
        } else {
            removeItem("isEditing");
        }
    }, [isEditing])*/

    useEffect(() => {
        const params = new URLSearchParams(search);
        if (params.get('edicionExitosa')) {
            //setShowToast(true); //no usar por ahora
            toast("¡Operación exitosa!, registro editado")
            // Limpiar el parámetro de la URL
            const newSearch = new URLSearchParams(search);
            newSearch.delete('edicionExitosa');
            const newUrl = [location.pathname, newSearch.toString()].filter(Boolean).join('?');
            window.history.replaceState({}, '', newUrl);
        }
    }, [location.search]);    

	useEffect(() => {
		console.log("estadoAppX", estadoAppX)
		cambiarEstadoApp("inicial")
	}, []) //cuando se monta el componente volver al estado inicial
	//const {isAuthenticated} = useContext(AuthContext)
    
    // Inicializar conexión Socket.IO (una sola vez)
    useEffect(() => {
        const s = initiateSocketConnection();
        setSocket(s);
        socketRef.current = s;

        const onConnect = () => {
            console.log('[socket] connected', s.id);
            setIsSocketConnected(true);
        };
        const onDisconnect = () => {
            console.log('[socket] disconnected');
            setIsSocketConnected(false);
        };

        s.on('connect', onConnect);
        s.on('disconnect', onDisconnect);

        // 2. Escuchar el evento
        s.on(EVENT_NAME, (payload) => {
            console.log('Evento recibido:', payload);
            setKey(payload.key);
            //PRO AHORA NO---- >setMessage(`✅ ¡Clave "${payload.key}" eliminada! Notificación recibida a las ${new Date(payload.timestamp).toLocaleTimeString()}`);

            //No recarga las obras, solo chequea el array_editando
            consultar_array_editando();

        });

        return () => {
            s.off('connect', onConnect);
            s.off('disconnect', onDisconnect);
            s.off(EVENT_NAME);
            try { s.close(); } catch (e) { }
        };
    }, []);

    useEffect(() => {
        consultar_array_editando(); //ahora para todos los usuarios

    }, [])

    useEffect(() => {
        if (socket) {
            console.log("ESTÄ ESCUCHANDO??")
            const procesarArray = (data) => {
                console.log("ESCUCHAR CAMBIOS aca´ --->", data)
                setArrayEditando(data)
            }
            socket.on("array_editando", procesarArray)

            return () => {
                socket.off("array_editando", procesarArray)
            }
        }
    }, [socket])

	return (
        <>
            {/* {showToast && (
                <div className="fixed top-4 right-4 z-50">
                    <div className="bg-green-500 text-white px-4 py-2 rounded shadow-lg">
                        ¡Operación exitosa!, registro editado
                    </div>
                </div>
            )} */}
            <div className="flex flex-col mb-6 p-4 bg-gray-100  dark:bg-gray-900 rounded-lg shadow-sm">
                <div className="flex flex-col p-4 mb-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
                    <a 
                        href="https://docs.google.com/spreadsheets/d/1kQ9YeNzulk6DFWxpAcTDM7oLfCpHVy722KNznL-g1_g/edit?gid=0#gid=0" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="inline-flex items-center text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 font-medium transition-colors"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h2a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                        Beta: Informar errores/sugerencias
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                            <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
                        </svg>
                    </a>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">¡Tu opinión nos ayuda a mejorar!</p>
                </div>
                {/*Ventana Tramitaciones*/}			
                <div className="w-full">
                    <TramitacionesComponent arrayEditando={arrayEditando} handleIsEditing={handleIsEditing}/>
                </div>
            </div>
            <ToastContainer />
        </>
	)
}